import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6ec48eea = () => interopDefault(import('../pages/academy/index.vue' /* webpackChunkName: "pages/academy/index" */))
const _486a4e2e = () => interopDefault(import('../pages/admin/index.vue' /* webpackChunkName: "pages/admin/index" */))
const _44fe8738 = () => interopDefault(import('../pages/forgot-password/index.vue' /* webpackChunkName: "pages/forgot-password/index" */))
const _084d1526 = () => interopDefault(import('../pages/get-started.vue' /* webpackChunkName: "pages/get-started" */))
const _64511fae = () => interopDefault(import('../pages/my-list-courses/index.vue' /* webpackChunkName: "pages/my-list-courses/index" */))
const _8c8233b8 = () => interopDefault(import('../pages/not-found.vue' /* webpackChunkName: "pages/not-found" */))
const _5b49621d = () => interopDefault(import('../pages/not-permission.vue' /* webpackChunkName: "pages/not-permission" */))
const _651c82cf = () => interopDefault(import('../pages/performance/index.vue' /* webpackChunkName: "pages/performance/index" */))
const _01ed1233 = () => interopDefault(import('../pages/personal-profile/index.vue' /* webpackChunkName: "pages/personal-profile/index" */))
const _4a07d182 = () => interopDefault(import('../pages/reflection/index.vue' /* webpackChunkName: "pages/reflection/index" */))
const _15f2a14b = () => interopDefault(import('../pages/report/index.vue' /* webpackChunkName: "pages/report/index" */))
const _85efeb8e = () => interopDefault(import('../pages/signin/index.vue' /* webpackChunkName: "pages/signin/index" */))
const _22d45aac = () => interopDefault(import('../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _50c0ee71 = () => interopDefault(import('../pages/training/index.vue' /* webpackChunkName: "pages/training/index" */))
const _774eedd6 = () => interopDefault(import('../pages/academy/calendar.vue' /* webpackChunkName: "pages/academy/calendar" */))
const _b7158cc4 = () => interopDefault(import('../pages/academy/class-activity/index.vue' /* webpackChunkName: "pages/academy/class-activity/index" */))
const _799caba2 = () => interopDefault(import('../pages/academy/edit-active.vue' /* webpackChunkName: "pages/academy/edit-active" */))
const _5e97c1b6 = () => interopDefault(import('../pages/academy/home.vue' /* webpackChunkName: "pages/academy/home" */))
const _0e05ec68 = () => interopDefault(import('../pages/academy/my-activity/index.vue' /* webpackChunkName: "pages/academy/my-activity/index" */))
const _36fbb946 = () => interopDefault(import('../pages/academy/progress-request.vue' /* webpackChunkName: "pages/academy/progress-request" */))
const _2013b01e = () => interopDefault(import('../pages/academy/schedule/index.vue' /* webpackChunkName: "pages/academy/schedule/index" */))
const _33751d9c = () => interopDefault(import('../pages/admin/course/index.vue' /* webpackChunkName: "pages/admin/course/index" */))
const _be359858 = () => interopDefault(import('../pages/admin/features/index.vue' /* webpackChunkName: "pages/admin/features/index" */))
const _02df210f = () => interopDefault(import('../pages/admin/performance/index.vue' /* webpackChunkName: "pages/admin/performance/index" */))
const _78c8514b = () => interopDefault(import('../pages/admin/school/index.vue' /* webpackChunkName: "pages/admin/school/index" */))
const _91405696 = () => interopDefault(import('../pages/admin/trainers/index.vue' /* webpackChunkName: "pages/admin/trainers/index" */))
const _217893f0 = () => interopDefault(import('../pages/api/healthz/index.vue' /* webpackChunkName: "pages/api/healthz/index" */))
const _892683b6 = () => interopDefault(import('../pages/my-list-courses/MyListCourses.vue' /* webpackChunkName: "pages/my-list-courses/MyListCourses" */))
const _235b1939 = () => interopDefault(import('../pages/performance/all-appraisal/index.vue' /* webpackChunkName: "pages/performance/all-appraisal/index" */))
const _0e8c65d5 = () => interopDefault(import('../pages/performance/appraisal-given/index.vue' /* webpackChunkName: "pages/performance/appraisal-given/index" */))
const _5046e63c = () => interopDefault(import('../pages/performance/appraisal-period.vue' /* webpackChunkName: "pages/performance/appraisal-period" */))
const _2690c576 = () => interopDefault(import('../pages/performance/assign/index.vue' /* webpackChunkName: "pages/performance/assign/index" */))
const _d98f1010 = () => interopDefault(import('../pages/performance/import.vue' /* webpackChunkName: "pages/performance/import" */))
const _3ce1cc4c = () => interopDefault(import('../pages/performance/my-appraisal/index.vue' /* webpackChunkName: "pages/performance/my-appraisal/index" */))
const _99b3ae74 = () => interopDefault(import('../pages/performance/overview-frameworks.vue' /* webpackChunkName: "pages/performance/overview-frameworks" */))
const _1ff06af0 = () => interopDefault(import('../pages/performance/performance-frameworks/index.vue' /* webpackChunkName: "pages/performance/performance-frameworks/index" */))
const _8aba4d62 = () => interopDefault(import('../pages/performance/print-pdf.vue' /* webpackChunkName: "pages/performance/print-pdf" */))
const _70d007cd = () => interopDefault(import('../pages/performance/review-process.vue' /* webpackChunkName: "pages/performance/review-process" */))
const _288f730c = () => interopDefault(import('../pages/performance/school-admin/index.vue' /* webpackChunkName: "pages/performance/school-admin/index" */))
const _34deeb42 = () => interopDefault(import('../pages/personal-profile/basic-info/index.vue' /* webpackChunkName: "pages/personal-profile/basic-info/index" */))
const _7d8dc7fe = () => interopDefault(import('../pages/personal-profile/training-records/index.vue' /* webpackChunkName: "pages/personal-profile/training-records/index" */))
const _1746670a = () => interopDefault(import('../pages/personal-profile/work-experience/index.vue' /* webpackChunkName: "pages/personal-profile/work-experience/index" */))
const _ecbe91e8 = () => interopDefault(import('../pages/reflection/daily/index.vue' /* webpackChunkName: "pages/reflection/daily/index" */))
const _6653e27a = () => interopDefault(import('../pages/school-profile/basic.vue' /* webpackChunkName: "pages/school-profile/basic" */))
const _49cd01a3 = () => interopDefault(import('../pages/settings/academy-training.vue' /* webpackChunkName: "pages/settings/academy-training" */))
const _47c82de6 = () => interopDefault(import('../pages/settings/administration.vue' /* webpackChunkName: "pages/settings/administration" */))
const _4ef5d834 = () => interopDefault(import('../pages/settings/billing/index.vue' /* webpackChunkName: "pages/settings/billing/index" */))
const _46c996d8 = () => interopDefault(import('../pages/settings/performance.vue' /* webpackChunkName: "pages/settings/performance" */))
const _4fc5b2a2 = () => interopDefault(import('../pages/settings/permissions/index.vue' /* webpackChunkName: "pages/settings/permissions/index" */))
const _1cbe3ca4 = () => interopDefault(import('../pages/staff/add-staff/index.vue' /* webpackChunkName: "pages/staff/add-staff/index" */))
const _327239de = () => interopDefault(import('../pages/staff/all/index.vue' /* webpackChunkName: "pages/staff/all/index" */))
const _f5d37cba = () => interopDefault(import('../pages/staff/configuration.vue' /* webpackChunkName: "pages/staff/configuration" */))
const _69f651ee = () => interopDefault(import('../pages/training/create-course/index.vue' /* webpackChunkName: "pages/training/create-course/index" */))
const _2d90b188 = () => interopDefault(import('../pages/training/CreateCourse.vue' /* webpackChunkName: "pages/training/CreateCourse" */))
const _3c378380 = () => interopDefault(import('../pages/training/playlists.vue' /* webpackChunkName: "pages/training/playlists" */))
const _6c9c8e37 = () => interopDefault(import('../pages/performance/performance-frameworks/framework/index.vue' /* webpackChunkName: "pages/performance/performance-frameworks/framework/index" */))
const _591ea269 = () => interopDefault(import('../pages/reflection/weekly/everyone.vue' /* webpackChunkName: "pages/reflection/weekly/everyone" */))
const _15cd34f6 = () => interopDefault(import('../pages/reflection/weekly/my-reflections.vue' /* webpackChunkName: "pages/reflection/weekly/my-reflections" */))
const _3a0884d0 = () => interopDefault(import('../pages/reflection/weekly/my-team.vue' /* webpackChunkName: "pages/reflection/weekly/my-team" */))
const _751197fc = () => interopDefault(import('../pages/settings/billing/subscription/index.vue' /* webpackChunkName: "pages/settings/billing/subscription/index" */))
const _fa40a496 = () => interopDefault(import('../pages/staff/all/StaffListing.vue' /* webpackChunkName: "pages/staff/all/StaffListing" */))
const _45336076 = () => interopDefault(import('../pages/staff/all/TableFilter.vue' /* webpackChunkName: "pages/staff/all/TableFilter" */))
const _69b67d38 = () => interopDefault(import('../pages/training/playlist/create.vue' /* webpackChunkName: "pages/training/playlist/create" */))
const _2ee86ea1 = () => interopDefault(import('../pages/performance/performance-frameworks/framework/role.vue' /* webpackChunkName: "pages/performance/performance-frameworks/framework/role" */))
const _bcd3b816 = () => interopDefault(import('../pages/academy/my-activity/playlist/_playlistSlug.vue' /* webpackChunkName: "pages/academy/my-activity/playlist/_playlistSlug" */))
const _6d098dda = () => interopDefault(import('../pages/admin/performance/appraisal-detail-v2/_appraisalId.vue' /* webpackChunkName: "pages/admin/performance/appraisal-detail-v2/_appraisalId" */))
const _28e2690c = () => interopDefault(import('../pages/performance/performance-frameworks/framework/__mock__.js' /* webpackChunkName: "pages/performance/performance-frameworks/framework/__mock__" */))
const _6d17f1cd = () => interopDefault(import('../pages/performance/v2/edit-checklist/_appraisalId.vue' /* webpackChunkName: "pages/performance/v2/edit-checklist/_appraisalId" */))
const _72e2f8ed = () => interopDefault(import('../pages/reflection/weekly/form/_id.vue' /* webpackChunkName: "pages/reflection/weekly/form/_id" */))
const _08f91174 = () => interopDefault(import('../pages/reflection/weekly/profile/_id.vue' /* webpackChunkName: "pages/reflection/weekly/profile/_id" */))
const _0515c501 = () => interopDefault(import('../pages/training/playlist/edit/_slug.vue' /* webpackChunkName: "pages/training/playlist/edit/_slug" */))
const _670db4b7 = () => interopDefault(import('../pages/academy/course-detail/_slug.vue' /* webpackChunkName: "pages/academy/course-detail/_slug" */))
const _1d313d8a = () => interopDefault(import('../pages/academy/request-detail/_enrolId.vue' /* webpackChunkName: "pages/academy/request-detail/_enrolId" */))
const _5a363eed = () => interopDefault(import('../pages/admin/course/_slug/index.vue' /* webpackChunkName: "pages/admin/course/_slug/index" */))
const _44359f25 = () => interopDefault(import('../pages/admin/features/_feature.vue' /* webpackChunkName: "pages/admin/features/_feature" */))
const _8ca2815a = () => interopDefault(import('../pages/performance/appraisal-detail-v2/_appraisalId.vue' /* webpackChunkName: "pages/performance/appraisal-detail-v2/_appraisalId" */))
const _bb055098 = () => interopDefault(import('../pages/performance/appraisal-detail/_appraisalId.vue' /* webpackChunkName: "pages/performance/appraisal-detail/_appraisalId" */))
const _d07ff4ec = () => interopDefault(import('../pages/performance/assign/_staffIds.vue' /* webpackChunkName: "pages/performance/assign/_staffIds" */))
const _1f179749 = () => interopDefault(import('../pages/performance/performance-frameworks/_frameworkCode/index.vue' /* webpackChunkName: "pages/performance/performance-frameworks/_frameworkCode/index" */))
const _069faaae = () => interopDefault(import('../pages/personal-profile/training-records/_id.vue' /* webpackChunkName: "pages/personal-profile/training-records/_id" */))
const _ab12b81c = () => interopDefault(import('../pages/personal-profile/work-experience/_id.vue' /* webpackChunkName: "pages/personal-profile/work-experience/_id" */))
const _8059284a = () => interopDefault(import('../pages/training/course-draft/_slug.vue' /* webpackChunkName: "pages/training/course-draft/_slug" */))
const _373f3095 = () => interopDefault(import('../pages/performance/performance-frameworks/_frameworkCode/select.vue' /* webpackChunkName: "pages/performance/performance-frameworks/_frameworkCode/select" */))
const _0e3e8890 = () => interopDefault(import('../pages/admin/course/_slug/topic/_topicSlug.vue' /* webpackChunkName: "pages/admin/course/_slug/topic/_topicSlug" */))
const _05d222da = () => interopDefault(import('../pages/course-detail/_slug.vue' /* webpackChunkName: "pages/course-detail/_slug" */))
const _5c406e8c = () => interopDefault(import('../pages/reset-password/_token.vue' /* webpackChunkName: "pages/reset-password/_token" */))
const _ae240554 = () => interopDefault(import('../pages/staff/_staffId/profile/basic-info/index.vue' /* webpackChunkName: "pages/staff/_staffId/profile/basic-info/index" */))
const _5b5c39b8 = () => interopDefault(import('../pages/staff/_staffId/profile/training-records/index.vue' /* webpackChunkName: "pages/staff/_staffId/profile/training-records/index" */))
const _13fd3673 = () => interopDefault(import('../pages/staff/_staffId/profile/work-experience/index.vue' /* webpackChunkName: "pages/staff/_staffId/profile/work-experience/index" */))
const _1d9d4a20 = () => interopDefault(import('../pages/staff/_staffId/profile/training-records/_id.vue' /* webpackChunkName: "pages/staff/_staffId/profile/training-records/_id" */))
const _fb878cca = () => interopDefault(import('../pages/staff/_staffId/profile/work-experience/_id.vue' /* webpackChunkName: "pages/staff/_staffId/profile/work-experience/_id" */))
const _bf476024 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/academy",
    component: _6ec48eea,
    name: "academy"
  }, {
    path: "/admin",
    component: _486a4e2e,
    name: "admin"
  }, {
    path: "/forgot-password",
    component: _44fe8738,
    name: "forgot-password"
  }, {
    path: "/get-started",
    component: _084d1526,
    name: "get-started"
  }, {
    path: "/my-list-courses",
    component: _64511fae,
    name: "my-list-courses"
  }, {
    path: "/not-found",
    component: _8c8233b8,
    name: "not-found"
  }, {
    path: "/not-permission",
    component: _5b49621d,
    name: "not-permission"
  }, {
    path: "/performance",
    component: _651c82cf,
    name: "performance"
  }, {
    path: "/personal-profile",
    component: _01ed1233,
    name: "personal-profile"
  }, {
    path: "/reflection",
    component: _4a07d182,
    name: "reflection"
  }, {
    path: "/report",
    component: _15f2a14b,
    name: "report"
  }, {
    path: "/signin",
    component: _85efeb8e,
    name: "signin"
  }, {
    path: "/signup",
    component: _22d45aac,
    name: "signup"
  }, {
    path: "/training",
    component: _50c0ee71,
    name: "training"
  }, {
    path: "/academy/calendar",
    component: _774eedd6,
    name: "academy-calendar"
  }, {
    path: "/academy/class-activity",
    component: _b7158cc4,
    name: "academy-class-activity"
  }, {
    path: "/academy/edit-active",
    component: _799caba2,
    name: "academy-edit-active"
  }, {
    path: "/academy/home",
    component: _5e97c1b6,
    name: "academy-home"
  }, {
    path: "/academy/my-activity",
    component: _0e05ec68,
    name: "academy-my-activity"
  }, {
    path: "/academy/progress-request",
    component: _36fbb946,
    name: "academy-progress-request"
  }, {
    path: "/academy/schedule",
    component: _2013b01e,
    name: "academy-schedule"
  }, {
    path: "/admin/course",
    component: _33751d9c,
    name: "admin-course"
  }, {
    path: "/admin/features",
    component: _be359858,
    name: "admin-features"
  }, {
    path: "/admin/performance",
    component: _02df210f,
    name: "admin-performance"
  }, {
    path: "/admin/school",
    component: _78c8514b,
    name: "admin-school"
  }, {
    path: "/admin/trainers",
    component: _91405696,
    name: "admin-trainers"
  }, {
    path: "/api/healthz",
    component: _217893f0,
    name: "api-healthz"
  }, {
    path: "/my-list-courses/MyListCourses",
    component: _892683b6,
    name: "my-list-courses-MyListCourses"
  }, {
    path: "/performance/all-appraisal",
    component: _235b1939,
    name: "performance-all-appraisal"
  }, {
    path: "/performance/appraisal-given",
    component: _0e8c65d5,
    name: "performance-appraisal-given"
  }, {
    path: "/performance/appraisal-period",
    component: _5046e63c,
    name: "performance-appraisal-period"
  }, {
    path: "/performance/assign",
    component: _2690c576,
    name: "performance-assign"
  }, {
    path: "/performance/import",
    component: _d98f1010,
    name: "performance-import"
  }, {
    path: "/performance/my-appraisal",
    component: _3ce1cc4c,
    name: "performance-my-appraisal"
  }, {
    path: "/performance/overview-frameworks",
    component: _99b3ae74,
    name: "performance-overview-frameworks"
  }, {
    path: "/performance/performance-frameworks",
    component: _1ff06af0,
    name: "performance-performance-frameworks"
  }, {
    path: "/performance/print-pdf",
    component: _8aba4d62,
    name: "performance-print-pdf"
  }, {
    path: "/performance/review-process",
    component: _70d007cd,
    name: "performance-review-process"
  }, {
    path: "/performance/school-admin",
    component: _288f730c,
    name: "performance-school-admin"
  }, {
    path: "/personal-profile/basic-info",
    component: _34deeb42,
    name: "personal-profile-basic-info"
  }, {
    path: "/personal-profile/training-records",
    component: _7d8dc7fe,
    name: "personal-profile-training-records"
  }, {
    path: "/personal-profile/work-experience",
    component: _1746670a,
    name: "personal-profile-work-experience"
  }, {
    path: "/reflection/daily",
    component: _ecbe91e8,
    name: "reflection-daily"
  }, {
    path: "/school-profile/basic",
    component: _6653e27a,
    name: "school-profile-basic"
  }, {
    path: "/settings/academy-training",
    component: _49cd01a3,
    name: "settings-academy-training"
  }, {
    path: "/settings/administration",
    component: _47c82de6,
    name: "settings-administration"
  }, {
    path: "/settings/billing",
    component: _4ef5d834,
    name: "settings-billing"
  }, {
    path: "/settings/performance",
    component: _46c996d8,
    name: "settings-performance"
  }, {
    path: "/settings/permissions",
    component: _4fc5b2a2,
    name: "settings-permissions"
  }, {
    path: "/staff/add-staff",
    component: _1cbe3ca4,
    name: "staff-add-staff"
  }, {
    path: "/staff/all",
    component: _327239de,
    name: "staff-all"
  }, {
    path: "/staff/configuration",
    component: _f5d37cba,
    name: "staff-configuration"
  }, {
    path: "/training/create-course",
    component: _69f651ee,
    name: "training-create-course"
  }, {
    path: "/training/CreateCourse",
    component: _2d90b188,
    name: "training-CreateCourse"
  }, {
    path: "/training/playlists",
    component: _3c378380,
    name: "training-playlists"
  }, {
    path: "/performance/performance-frameworks/framework",
    component: _6c9c8e37,
    name: "performance-performance-frameworks-framework"
  }, {
    path: "/reflection/weekly/everyone",
    component: _591ea269,
    name: "reflection-weekly-everyone"
  }, {
    path: "/reflection/weekly/my-reflections",
    component: _15cd34f6,
    name: "reflection-weekly-my-reflections"
  }, {
    path: "/reflection/weekly/my-team",
    component: _3a0884d0,
    name: "reflection-weekly-my-team"
  }, {
    path: "/settings/billing/subscription",
    component: _751197fc,
    name: "settings-billing-subscription"
  }, {
    path: "/staff/all/StaffListing",
    component: _fa40a496,
    name: "staff-all-StaffListing"
  }, {
    path: "/staff/all/TableFilter",
    component: _45336076,
    name: "staff-all-TableFilter"
  }, {
    path: "/training/playlist/create",
    component: _69b67d38,
    name: "training-playlist-create"
  }, {
    path: "/performance/performance-frameworks/framework/role",
    component: _2ee86ea1,
    name: "performance-performance-frameworks-framework-role"
  }, {
    path: "/academy/my-activity/playlist/:playlistSlug",
    component: _bcd3b816,
    name: "academy-my-activity-playlist-playlistSlug"
  }, {
    path: "/admin/performance/appraisal-detail-v2/:appraisalId?",
    component: _6d098dda,
    name: "admin-performance-appraisal-detail-v2-appraisalId"
  }, {
    path: "/performance/performance-frameworks/framework/:_mock__",
    component: _28e2690c,
    name: "performance-performance-frameworks-framework-_mock__"
  }, {
    path: "/performance/v2/edit-checklist/:appraisalId?",
    component: _6d17f1cd,
    name: "performance-v2-edit-checklist-appraisalId"
  }, {
    path: "/reflection/weekly/form/:id?",
    component: _72e2f8ed,
    name: "reflection-weekly-form-id"
  }, {
    path: "/reflection/weekly/profile/:id?",
    component: _08f91174,
    name: "reflection-weekly-profile-id"
  }, {
    path: "/training/playlist/edit/:slug?",
    component: _0515c501,
    name: "training-playlist-edit-slug"
  }, {
    path: "/academy/course-detail/:slug?",
    component: _670db4b7,
    name: "academy-course-detail-slug"
  }, {
    path: "/academy/request-detail/:enrolId?",
    component: _1d313d8a,
    name: "academy-request-detail-enrolId"
  }, {
    path: "/admin/course/:slug",
    component: _5a363eed,
    name: "admin-course-slug"
  }, {
    path: "/admin/features/:feature",
    component: _44359f25,
    name: "admin-features-feature"
  }, {
    path: "/performance/appraisal-detail-v2/:appraisalId?",
    component: _8ca2815a,
    name: "performance-appraisal-detail-v2-appraisalId"
  }, {
    path: "/performance/appraisal-detail/:appraisalId?",
    component: _bb055098,
    name: "performance-appraisal-detail-appraisalId"
  }, {
    path: "/performance/assign/:staffIds",
    component: _d07ff4ec,
    name: "performance-assign-staffIds"
  }, {
    path: "/performance/performance-frameworks/:frameworkCode",
    component: _1f179749,
    name: "performance-performance-frameworks-frameworkCode"
  }, {
    path: "/personal-profile/training-records/:id",
    component: _069faaae,
    name: "personal-profile-training-records-id"
  }, {
    path: "/personal-profile/work-experience/:id",
    component: _ab12b81c,
    name: "personal-profile-work-experience-id"
  }, {
    path: "/training/course-draft/:slug?",
    component: _8059284a,
    name: "training-course-draft-slug"
  }, {
    path: "/performance/performance-frameworks/:frameworkCode?/select",
    component: _373f3095,
    name: "performance-performance-frameworks-frameworkCode-select"
  }, {
    path: "/admin/course/:slug/topic/:topicSlug?",
    component: _0e3e8890,
    name: "admin-course-slug-topic-topicSlug"
  }, {
    path: "/course-detail/:slug?",
    component: _05d222da,
    name: "course-detail-slug"
  }, {
    path: "/reset-password/:token?",
    component: _5c406e8c,
    name: "reset-password-token"
  }, {
    path: "/staff/:staffId?/profile/basic-info",
    component: _ae240554,
    name: "staff-staffId-profile-basic-info"
  }, {
    path: "/staff/:staffId?/profile/training-records",
    component: _5b5c39b8,
    name: "staff-staffId-profile-training-records"
  }, {
    path: "/staff/:staffId?/profile/work-experience",
    component: _13fd3673,
    name: "staff-staffId-profile-work-experience"
  }, {
    path: "/staff/:staffId?/profile/training-records/:id?",
    component: _1d9d4a20,
    name: "staff-staffId-profile-training-records-id"
  }, {
    path: "/staff/:staffId?/profile/work-experience/:id?",
    component: _fb878cca,
    name: "staff-staffId-profile-work-experience-id"
  }, {
    path: "/",
    component: _bf476024,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
